import BaseClass from "../BaseClass";
import Stepper from "./Stepper";

const defaultOptions = {};

/**
 * This class is used for handling searchs.
 */
export default class StepperWrapper extends BaseClass {

  constructor(options) {
    super(options, defaultOptions);

    window.steppers = {};

    this.init();
  }

  init() {
    $(document).ready(() => {
      window.steppers['cart'] = new Stepper('cart');
    });
  }
}
